import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-wrap justify-between items-center gap-4 mt-8 sm:flex-nowrap" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.previous && _ctx.previous(...args))),
      disabled: _ctx.isFirstQuestion,
      class: "w-full sm:w-auto px-4 py-2 text-sm sm:text-base rounded-lg font-medium transition-colors duration-200 disabled:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-50 enabled:bg-blue-600 enabled:hover:bg-blue-700 enabled:text-white"
    }, " Previous ", 8, _hoisted_2),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.next && _ctx.next(...args))),
      disabled: _ctx.isLastQuestion || !_ctx.hasAnswered,
      class: "w-full sm:w-auto px-4 py-2 text-sm sm:text-base rounded-lg font-medium transition-colors duration-200 disabled:bg-gray-300 disabled:cursor-not-allowed disabled:opacity-50 enabled:bg-blue-600 enabled:hover:bg-blue-700 enabled:text-white"
    }, " Next ", 8, _hoisted_3),
    (_ctx.isLastQuestion && _ctx.hasAnswered)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToPreview && _ctx.goToPreview(...args))),
          class: "w-full sm:w-auto px-4 py-2 text-sm sm:text-base rounded-lg font-medium transition-colors duration-200 enabled:bg-blue-600 enabled:hover:bg-blue-700 enabled:text-white"
        }, " Preview Answers "))
      : _createCommentVNode("", true)
  ]))
}